/**
 * @generated SignedSource<<0a074253ec066779a6a315d904109dc8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type detailHelpers_nftItem$data = {
  readonly contract: {
    readonly address: string | null;
    readonly name: string | null;
    readonly tokenContractImport: {
      readonly collectionName: string | null;
    } | null;
  } | null;
  readonly isERC1155: boolean | null;
  readonly metadata: {
    readonly edition?: string | null;
    readonly media?: {
      readonly dimensions: string | null;
      readonly url: string | null;
    } | null;
    readonly medium?: string | null;
    readonly name?: string | null;
  } | null;
  readonly tokenId: string | null;
  readonly tokenUri: string | null;
  readonly totalSupply: number | null;
  readonly " $fragmentType": "detailHelpers_nftItem";
};
export type detailHelpers_nftItem$key = {
  readonly " $data"?: detailHelpers_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"detailHelpers_nftItem">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "detailHelpers_nftItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tokenId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tokenUri",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NftTokenContract",
      "kind": "LinkedField",
      "name": "contract",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address",
          "storageKey": null
        },
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "NftTokenContractImport",
          "kind": "LinkedField",
          "name": "tokenContractImport",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "collectionName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "metadata",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "medium",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "edition",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "NftDigitalArtMetadataMedia",
              "kind": "LinkedField",
              "name": "media",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dimensions",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "NftDigitalArtMetadata",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalSupply",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isERC1155",
      "storageKey": null
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};
})();

(node as any).hash = "8f6aacff8cd33d90a24298a60114e682";

export default node;
